// extracted by mini-css-extract-plugin
export default {"content":"NewLoading_content__FOTx5","title":"NewLoading_title__aZKa8","date":"NewLoading_date__bfc0k","image":"NewLoading_image__fEn0X","share":"NewLoading_share__GVQOg"};